export function generateManifestDataUrl(event) {
  const manifestData = {
    name: event.name || "Forum Events",
    short_name: event.name || "Forum Events",
    description: event.name,
    start_url: window.location.href,
    scope: window.location.origin,
    id: "forum-events" + event.name,
    display: "standalone",
    background_color: "#222c2e",
    theme_color: "#222c2e",
    dir: "auto",
    lang: "en-US",
    icons: [
      {
        src: window.location.origin + require("@/assets/images/logos/forum-events-192.png"),
        sizes: "192x192",
        type: "image/png",
        purpose: "any",
      },
      {
        src: window.location.origin + require("@/assets/images/logos/forum-events-180.png"),
        sizes: "180x180",
        type: "image/png",
        purpose: "any",
      },
      {
        src: window.location.origin + require("@/assets/images/logos/forum-events-16.png"),
        sizes: "16x16",
        type: "image/png",
        purpose: "any",
      },
      {
        src: window.location.origin + require("@/assets/images/logos/forum-events-512-maskable.png"),
        sizes: "512x512",
        type: "image/png",
        purpose: "maskable",
      },
    ],
    screenshots: [
      {
        src: window.location.origin + require("@/assets/images/screenshots/screenshot-1.png"),
        sizes: "336x728",
        type: "image/png",
        label: event.name
      },
      {
        src: window.location.origin + require("@/assets/images/screenshots/screenshot-1.png"),
        sizes: "336x728",
        type: "image/png",
        label: event.name,
        form_factor: "wide"
      },
    ],
  }

  const jsonString = JSON.stringify(manifestData, null, 2)
  const blob = new Blob([jsonString], {type: "application/json"})
  return URL.createObjectURL(blob)
}
